import React from "react";
import "./PaymentDetails.scss";
import "./payment-details-responsive.scss";
import { IPaymentDetailsProps } from "./IPaymentDetailsProps";

const PaymentDetails = (props: IPaymentDetailsProps): JSX.Element => {

  return (
    <div className="payment-details-card-info">
      {props.group &&
        props.group.user_membership &&
        props.group.user_membership.pm_type && 
        !props.paymentData ? (
        <div className="card-info-form">
          <div className="card-info-top">
            <p className="card-info-single">
              Card number:
              <br />
              <strong className="brand">
                **** **** ****{" "}
                {props.group.user_membership.pm_last_four &&
                  props.group.user_membership.pm_last_four}
              </strong>
            </p>
            <p className="card-info-single">
              Expiration date:
              <br />
              <strong className="brand">
                {props.group.user_membership.card_exp_month &&
                  props.group.user_membership.card_exp_month}{" "}
                /{" "}
                {props.group.user_membership.card_exp_year &&
                  props.group.user_membership.card_exp_year}
              </strong>
            </p>
            <p className="card-info-single">
              CVC Code:
              <br />
              <strong className="brand">***</strong>
            </p>
          </div>
          <div className="card-info-bottom">
            <span
              onClick={() => {
                props.onUpdateCard();
              }}
            >
              Update Card
            </span>
          </div>
        </div>
      ) : (
        <>
          {props.paymentData && (
            <div className="card-info-form">
              <div className="card-info-top">
                <p className="card-info-single">
                  Card number:
                  <br />
                  <strong className="brand">
                    **** **** ****{" "}
                    {props.paymentData &&
                      props.paymentData.paymentMethod &&
                      props.paymentData.paymentMethod.card.last4}
                  </strong>
                </p>
                <p className="card-info-single">
                  Expiration date:
                  <br />
                  <strong className="brand">
                    {props.paymentData &&
                      props.paymentData.paymentMethod &&
                      props.paymentData.paymentMethod.card.exp_month}{" "}
                    /{" "}
                    {props.paymentData &&
                      props.paymentData.paymentMethod &&
                      props.paymentData.paymentMethod.card.exp_year}
                  </strong>
                </p>
                <p className="card-info-single">
                  CVC Code:
                  <br />
                  <strong className="brand">***</strong>
                </p>
              </div>
              <div className="card-info-bottom">
                <span />
                <span
                  onClick={() => {
                    props.onUpdateCard();
                  }}
                >
                  Update Card
                </span>
              </div>
            </div>
          )}
        </>
        
      )}
    </div>
    
  );
};

export default PaymentDetails;
